import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";

export const FilterButton = styled.button`
	background: transparent;
	border: 0;
	padding: 8px 16px;
	border-radius: 8px;

	&.active {
		color: ${colors.mainColors.blueberry};
		font-weight: bold;
	}

	&:hover {
		background: ${colors.mainColors.white_lilac};
	}
`;
